var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "col cat-row", class: { frt: _vm.activeCard } },
    [
      _c("h5", { style: { color: _vm.Global.mockupConfig.colors.icons } }, [
        _vm._v(_vm._s(_vm.rowTitle)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "outer", staticClass: "row-outer" },
        [
          _c(
            "transition",
            { attrs: { name: "fadescale" }, on: { css: false } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.numToSlide > 0,
                      expression: "numToSlide > 0",
                    },
                  ],
                  staticClass: "nv bw",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.prv.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "17",
                          height: "40",
                          viewBox: "0 0 17 40",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15 38L2.42285 20.5855C2.17042 20.236 2.17043 19.764 2.42285 19.4145L15 2",
                            stroke: "white",
                            "stroke-width": "4",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "inner",
              staticClass: "row-inner",
              class: { dsbld: _vm.tempDsbld },
              style: _vm.innerStyle,
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fadescale" }, on: { css: false } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.numToSlide < _vm.totalHidden,
                      expression: "numToSlide < totalHidden",
                    },
                  ],
                  staticClass: "nv fw",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.nxt.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "17",
                          height: "40",
                          viewBox: "0 0 17 40",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M2 2L14.5771 19.4145C14.8296 19.764 14.8296 20.236 14.5771 20.5855L2 38",
                            stroke: "white",
                            "stroke-width": "4",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }